import type { Character } from '@/types/character';

const CHAR_LABELS: Array<[keyof Character['characteristics'], string]> = [
  ['intelligence', 'Int'],
  ['perception', 'Per'],
  ['strength', 'Str'],
  ['stamina', 'Sta'],
  ['presence', 'Pre'],
  ['communication', 'Com'],
  ['dexterity', 'Dex'],
  ['quickness', 'Qik'],
];

function fmt(n: number): string {
  return n >= 0 ? `+${n}` : `${n}`;
}

export function CharacterCore({ c }: { c: Character }) {
  return (
    <div className="card space-y-4">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div>
          <h2 className="font-serif text-3xl text-parchment-50">{c.name}</h2>
          <div className="text-xs muted uppercase tracking-[0.2em]">
            Grog · age {c.age} · native {c.nativeLanguage}
          </div>
        </div>
        {c.covenant?.name && (
          <div className="text-right">
            <div className="font-display text-[11px] uppercase tracking-[0.28em] text-gold-400">
              Covenant
            </div>
            <div className="text-sm">{c.covenant.name}</div>
            {c.covenant.role && <div className="text-xs muted">{c.covenant.role}</div>}
          </div>
        )}
      </div>

      {c.appearance && (
        <p className="text-sm italic text-parchment-100/75">{c.appearance}</p>
      )}

      <div>
        <div className="font-display text-[11px] uppercase tracking-[0.28em] text-gold-400 mb-2">
          Characteristics
        </div>
        <div className="grid grid-cols-4 gap-2 sm:grid-cols-8">
          {CHAR_LABELS.map(([key, label]) => (
            <div
              key={key}
              className="rounded-sm border border-gold-400/20 bg-ink-800/40 p-2 text-center"
            >
              <div className="font-display text-[10px] uppercase tracking-[0.18em] text-gold-400">
                {label}
              </div>
              <div className="font-serif text-xl text-parchment-50">
                {fmt(c.characteristics[key])}
              </div>
            </div>
          ))}
        </div>
      </div>

      {c.notes && (
        <p className="text-xs muted border-t border-gold-400/15 pt-3">{c.notes}</p>
      )}
    </div>
  );
}
